module.exports = __webpack_public_path__ + "img/word-01.8629f59b.png";